<div class="dashboard--module-header">
    <h2 class="subheading-sm">Meter reading frequency in last 60 days<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-read-data-availability-chart class="block-chart"></issues-read-data-availability-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Supply</th>
            <th>Meter ID</th>
            <th>% frequency</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.meterAddress}}</td>
                    <td data-label="Supply">{{item.supplyType}}</td>
                    <td data-label="Meter ID">{{item.meterSerial}}</td>
                    <td data-label="% frequency">{{item.functionality | number:'1.2-2'}}%</td>
                    <td class="text-right" *ngIf="clientId"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
